export const iconFontAwesomeTravelHotelTruckPlane = (
	<i className="fa-solid fa-truck-plane"></i>
);
